import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../auth/auth-context';
import { AuthShell } from '../components/auth-shell';
import { usePageTitle } from '../lib/page-title';

export function ResetConfirmPage() {
  usePageTitle('Choose a new password');
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setErrorMessage(null);
    const { error } = await auth.updateUser({ password });
    setSubmitting(false);
    if (error) {
      setErrorMessage(error.message);
      return;
    }
    void navigate('/account', { replace: true });
  }

  return (
    <AuthShell>
      <h1>Choose a new password</h1>
      <p>Use at least 12 characters. You’ll stay signed in afterwards.</p>
      <form className="auth-form" onSubmit={(event) => void submit(event)}>
        <label>
          New password
          <input
            type="password"
            autoComplete="new-password"
            required
            minLength={12}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {errorMessage ? (
          <p className="form-error" role="alert">
            {errorMessage}
          </p>
        ) : null}
        <button type="submit" disabled={submitting}>
          {submitting ? 'Updating…' : 'Update password'}
        </button>
      </form>
    </AuthShell>
  );
}
